import { render, staticRenderFns } from "./DataSelection.vue?vue&type=template&id=4a43035e&scoped=true"
import script from "./DataSelection.vue?vue&type=script&lang=js"
export * from "./DataSelection.vue?vue&type=script&lang=js"
import style0 from "./DataSelection.vue?vue&type=style&index=0&id=4a43035e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a43035e",
  null
  
)

export default component.exports